<template>
  <form-group>
    <div class="form-group">
      <label :for="label_for">{{ label_text }}</label>
      <br/>
      <!-- TO REFACTOR VALUE OR V-MODEL -->
      <div class="form-check form-check-inline" v-for="d in radioCategories" :key="d.id">
        <input class="form-check-input"
          v-model="selectedValue"
          type="radio"
          :name="d.name"
          :value="d.value">
        <label class="form-check-label">{{ d.value }}</label>
      </div>
    </div>
  </form-group>
</template>


<script>
export default {
  props: {
    label_text: {
      value: String
    },
    radioCategories: {
      value: Array,
      default: []
    },
    label_for: {
      type: String,
      default: ''
    },
    selectedValue: String
  },
  computed: {
    input_v_model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/InlineRadioComponent.vue